<template>
  <div>
    <p class="light-gray">
      {{ $t('placeholder.cost') }}
    </p>
    <Slider
      :value="trainerCost"
      :min-value="minCost"
      :max-value="maxCost"
      :pre-str="currencySign"
      class="cost-slider"
      @changeValue="getCost"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import constants from '@/dependencies/constants'
import Slider from '~/components/Common/Slider'

export default {
  name: 'Cost',
  components: {
    Slider
  },
  data() {
    return {
      defaultCost: [constants.COMMON.MIN_COST, constants.COMMON.MAX_COST],
      cost: null
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/getCurrencySign',
      searchCost: 'search/searchCost'
    }),
    minCost() {
      return constants.COMMON.MIN_COST
    },
    maxCost() {
      return constants.COMMON.MAX_COST
    },
    trainerCost() {
      return this.searchCost ? this.searchCost : this.defaultCost
    }
  },
  methods: {
    ...mapActions({
      setCost: 'search/SET_COST'
    }),
    getCost(cost) {
      this.age = cost
      this.setCost(cost)
    }
  }
}
</script>

<style scoped></style>
